import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Container, Grid, Divider } from '@mui/material'
import { useLocation } from 'react-router-dom'
import AboutPageSection from '../../components/AboutPageSection'
import founderImage from '../../images/founder.jpg';
import rawRingImage from '../../images/raw-ring.png';
import { founderBody, brandBody } from '../../content/about';

const About = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [hash]);

  return (
    <Container sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }} maxWidth={false} disableGutters>
      <Header/>
      <Container component='main' maxWidth={false} sx={{ flex: 1, pt: '80px' }} disableGutters>
        <Grid size={12}>
          <Divider sx={{ mx: 4, opacity: 1 }}/>
        </Grid>
        <AboutPageSection 
          id="about-founder"
          body={founderBody}
          image={founderImage}
          imagePosition="left"
          title="iet'ene ka mang?"
          titleTooltip="Meaning: Who founded iets'ene?"
        />
        <Grid size={12}>
          <Divider sx={{ mx: 4, my: 4, opacity: 1 }}/>
        </Grid>
        <AboutPageSection 
          id="about-ietsene"
          body={brandBody}
          image={rawRingImage}
          imagePosition="right"
          title="iets'ene ke eng?"
          titleTooltip="Meaning: What is iets'ene?"
        />
      </Container>
      <Footer/>
    </Container>
  )
}

export default About
